import { useNavigate } from 'react-router-dom';
import { ReactComponent as SearchIcon } from '@/assets/steam/search-icon.svg';
import './Institute.scss';
import { useEffect, useState, useRef } from 'react';
import BackIcon from '@/assets/rewise/back-icon.svg';
import { useGetInstituteList } from '../api/getInstitute';
import { ArchiveIcon } from '@heroicons/react/outline';
import { Institute, UserRole, State } from '../types/indes';
import { showNotification } from '@/utils/notificationUtils';
import { Loader } from '@/components/Loader/Loader';
import noDataAnimation from '@/assets/animation/loading.json';
import Lottie from 'lottie-react';
import Filter, { ReactComponent as FilterIcon } from '@/assets/steam/filter.svg';
import Delete from '@/assets/steam/delete.svg';
import View from '@/assets/steam/view.svg';
import Edit from '@/assets/steam/edit.svg';
import { TableData } from '@/components/Table/TableData';
import { PageHeader } from '@/components/PageHeaders/PageHeader';
import Utils from '@/utils/util';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import AddNewUser from '../components/editInstitute';
import { useGetStateList, useGetUserRoleList } from '../../users/api/getRefrences';
import { FilterMenu } from '@/components/Elements/FilterMenu';
import AddNewLocation from '../components/editInstitute';
import EditInstitute from '../components/editInstitute';
import { useDeleteContact } from '@/features/contact/api/deleteContact';
import { useDeleteInstitute } from '../api/deleteInstitute';
import DeleteConfirmation from '@/components/DeleteConfirmation/DeleteConfirmation';

export const Institutes = () => {
  const [contactList, setContactList] = useState<Institute[]>([]);

  const [isAddNewInstitute, setIsAddNewInstitute] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [tableCurrentIndex, setTableCurrentIndex] = useState(1);
  const perPage = 10;
  const [searchString, setSearchString] = useState('');
  const [filteredList, setFilteredList] = useState<Institute[]>([]);
  const [productDetails, setProductDetails] = useState<Institute>();
  const useGetUsersMutation = useGetInstituteList();
  const [roles, setRoles] = useState<UserRole[]>([]);
  const [states, setStates] = useState<State[]>([]);
  const [editInstituteData, seteditInstituteData] = useState<any>(null);
  const useGetUserRoleMutation = useGetUserRoleList();
  const useGetStateMutation = useGetStateList();
  const [filteredContactList, setFilteredContactList] = useState<Institute[]>([]);
  const useDeleteUserMutation = useDeleteInstitute();

  const [selectedContactList, setSelectedContactList] = useState<number[]>([]);
  const [selectedContact, setSelectedContact] = useState<any>();
  const [addMessageOnWp, setAddMessageOnWp] = useState(false);
  const [viewMessageDialog, setViewMessageDialog] = useState(false);
  const [isDeleteTrue, setIsDeleteTrue] = useState<any>();

  useEffect(() => {
    getInstituteList(1, true);
    getUserRoleList();
    getStateList()
  }, []);

  const getUserRoleList = async () => {
    const res = await useGetUserRoleMutation.mutateAsync({
      search: ''
    });
    if (res) {
      setRoles(res.list);
    }
  };


  const getStateList = async () => {
    const res = await useGetStateMutation.mutateAsync({
      search: ''
    });
    if (res) {
      setStates(res.list);
    }
  };



  const getInstituteList = async (pageIndex: number, reset = false, filter?: any, isOnlyEdit?: any) => {
    const res = await useGetUsersMutation.mutateAsync({
      page: pageIndex,
      perPage: perPage,
      search: searchString,
      filter,
    });

    setTotalPages(res.totalPages);
    setTotalRecords(res.total);
    if (isOnlyEdit) {
      setContactList(res.list);
      if (pageIndex) setTableCurrentIndex(pageIndex);
      if (searchString) {
        setFilteredList(res.list);
      }
    } else if (reset) {
      setContactList(res.list);
      if (pageIndex) {
        setTableCurrentIndex(pageIndex);
      } else {
        setTableCurrentIndex(tableCurrentIndex);
      }
      if (searchString) {
        setFilteredList(res.list);
      }
    } else {
      setContactList(contactList.concat(res.list));
      if (pageIndex) {
        setTableCurrentIndex(pageIndex);
      } else {
        setTableCurrentIndex(tableCurrentIndex);
      }
    }
  };

  const searchUser = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchString = e.target.value;
    setSearchString(searchString);
    const res = await useGetUsersMutation.mutateAsync({
      page: 1,
      perPage: perPage,
      search: searchString,
    });
    setContactList(res.list);
    if (searchString) {
      setFilteredList(res.list);
    } else {
      setFilteredList([]);
    }
    setTotalPages(res.totalPages);
    setTotalRecords(res.total);
  };

  const actualList = filteredList.length ? filteredList : contactList;

  const onTableStateChange = (pageIndex: number) => {
    if (totalPages >= pageIndex) {
      getInstituteList(pageIndex, true);
    }
  };

  const deleteInstitute = async (id: any) => {
    const res = await useDeleteUserMutation.mutateAsync({
      id
    });
    if (res) {
      getInstituteList(tableCurrentIndex, true);
      setIsDeleteTrue('')
    } else {
      setIsDeleteTrue('')
    }
  }

  const onClose = () => {
    setIsDeleteTrue('');
  }
  const selectAllContacts = () => {
    const services: number[] = [];
    if (selectedContactList.length) {
      setSelectedContactList([]);
    } else {
      const ContactListCurrent = filteredContactList.length ? filteredContactList : contactList;
      ContactListCurrent.forEach((sl: Institute) => sl.id && services.push(parseInt(sl.id)));
      setSelectedContactList(services);
    }
  };

  const selectContact = (service: Institute) => {
    if (service?.id) {
      const filteredIndex = selectedContactList.indexOf(parseInt(service?.id));
      if (filteredIndex < 0) {
        selectedContactList.push(parseInt(service?.id));
      } else {
        selectedContactList.splice(filteredIndex, 1);
      }
      setSelectedContactList([...selectedContactList]);
    }
  };

  const messageThroughWati = () => {
    setAddMessageOnWp(true);
  }

  const resetData = () => {
    setSelectedContactList([]);
  }
  return (
    <>

      <div className="users-list-container">
        <PageHeader title='Institute List' description='' />
        <div className='search-container'>
          <div className='search-filter-container'>

            <span className="search-content">
              <SearchIcon />
              <input
                type="text"
                id="simple-search"
                placeholder="Search by Institute Name"
                onChange={searchUser}
                className="steam-search"
              />
            </span>
            <div>
              <div className="action-btn">
                <FilterMenu roles={roles} states={states} options={[]} onRoleSelect={(filter) => {
                  if (filter) {
                    getInstituteList(1, true, filter)
                  } else {
                    getInstituteList(1, true)
                  }
                }} showRoleFilter={false} />
              </div>
            </div>

          </div>
          <div className='add-user-container'>
            {/* {selectedContactList && selectedContactList.length > 0 && <button className='steam-button button-dark' onClick={() => { messageThroughWati() }}>Send Message On Whatsapp</button>} */}

          </div>
        </div>
        <div className="users-list petsked-table">
          {useGetUsersMutation.isLoading && !searchString && (
            <div className="h-full w-full flex items-center justify-center  ">
              <Lottie className="loading-loader-class" animationData={noDataAnimation} />
            </div>
          )}

          <TableData<Institute>
            data={actualList}
            columns={[
              {
                title: 'Institute Name',
                field: 'name',
                Cell({ entry }) {
                  return (
                    <div className="users-container">
                      <div>
                        <InitialsAvatar name={entry && entry.name ? entry.name : 'SA'} className="avatar" />
                      </div>
                      <div className="user-details-container">

                        <div className="user-tab-name">
                          <div className="name">{entry?.name}</div>
                        </div>
                      </div>
                    </div>
                  );
                },
              },
              {
                title: 'Address',
                field: 'name',
                Cell({ entry }) {
                  return (
                    <div className="table-user-role fixed-width">
                      {entry?.address}

                    </div>
                  );
                },
              },
              {
                title: 'State',
                field: 'name',
                Cell({ entry: { state } }) {
                  return (
                    <div className="table-user-role">{state?.name}
                    </div>
                  );
                },
              },
              {
                title: 'City',
                field: 'name',
                Cell({ entry: { city } }) {
                  return (
                    <div className="table-user-role">{city?.name}
                    </div>
                  );
                },
              },
              {
                title: 'Created At',
                field: 'name',
                Cell({ entry: { createdAt } }) {
                  return (
                    <div className="table-date">
                      {Utils.formatDate(
                        createdAt
                      )}
                    </div>
                  );
                },
              },

              {
                title: 'Action',
                field: 'id',
                Cell({ entry }) {
                  return (
                    <div className="user-btn-container">

                      <div className="edit-btn" onClick={() => { seteditInstituteData(entry); setIsAddNewInstitute(true) }} >
                        <img src={Edit} />
                      </div>
                      <div className="edit-btn" onClick={() => { setIsDeleteTrue(entry.id) }} >
                        <img src={Delete} />
                      </div>
                    </div>
                  );
                },
              },
            ]}
            tableInitialState={{
              tableTotalRecords: totalPages,
              tablePageIndex: tableCurrentIndex,
            }}
            onTableStateChange={onTableStateChange}
            showPagination={true}
            isDataLoading={useGetUsersMutation?.isLoading}
          />
        </div>

        <EditInstitute onConfirm={() => { resetData(); setIsAddNewInstitute(false); getInstituteList(tableCurrentIndex, false, null, true) }} onClose={() => { resetData(); setIsAddNewInstitute(false); seteditInstituteData(null) }} open={isAddNewInstitute} editInstituteData={editInstituteData} />
        {isDeleteTrue && <DeleteConfirmation open={isDeleteTrue ? true : false} onClose={onClose} onConfirm={(data?: any) => deleteInstitute(isDeleteTrue)} message='Are you sure you want to delete this institute? This will delete all the funnels and contact data related to this institute.' subText='Delete Institute' />}
      </div>

    </>
  );
};
